import React from 'react';

import { Frame } from 'common/components';

import { ModalAction } from 'common/redux/modal/initialState';

import './index.css';

type Props = Partial<ModalAction>;

const CryptoPayPopup: React.FC<React.PropsWithChildren<Props>> = () => {
  const FRAME_URL = `${window.location.origin}/client-area/get-link?iframe=true`;

  return <Frame className='crypto-pay__frame panel' dataAttribute='crypto-pay__frame' url={FRAME_URL} />;
};

export default (props?: Props) => ({
  component: <CryptoPayPopup {...props} />,
  hideCloseIcon: true,
  closeOnClickOutside: true,
  title: '',
  wrapperClassName: 'crypto-pay',
  useBottomSheet: true,
  ...props,
});
